import CookieHelper from "@Scripts/Infrastructure/CookieHelper";
import BasePage from "@Scripts/Pages/BasePage";

export default class CookieTermsPage extends BasePage {
    public static async init() {
        await super.init();

        var $buttonOptInAll = $(".opt-in-all"),
            $buttonOptOutAll = $(".opt-out-all"),
            $buttonOptIn = $(".opt-in"),
            $buttonOptOut = $(".opt-out");

        var cookie = CookieHelper.getCookiePolicy();
        if (cookie) {
            var values = cookie.split("|");

            if (values.indexOf("stat") !== -1) {
                $(".stat-status-on").show();
            } else {
                $(".stat-status-off").show();
            }

            if (values.indexOf("profile") !== -1) {
                $(".profile-status-on").show();
            } else {
                $(".profile-status-off").show();
            }
        }

        $buttonOptInAll.on("click", function () {
            CookieHelper.setCookiePolicyAll();
            window.location.reload();
        });

        $buttonOptOutAll.on("click", function () {
            CookieHelper.removeCookiePolicyAll();
            window.location.reload();
        });

        $buttonOptIn.on("click", function () {
            CookieHelper.setCookiePolicyType($(this).data("type"));
            window.location.reload();
        });

        $buttonOptOut.on("click", function () {
            CookieHelper.removeCookiePolicyType($(this).data("type"));
            window.location.reload();
        });
    }
}